import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { medication } from "src/types";

const initialState: medication.MedicationStateType = {
  medicationsList: {
    isLoading: false,
    error: null,
    data: null,
  },
  medicationById: {
    isLoading: false,
    error: null,
    data: null,
  },
  addMedication: {
    isLoading: false,
    error: null,
    data: null,
  },
  editMedication: {
    isLoading: false,
    error: null,
    data: null,
  },
  deleteMedication: {
    isLoading: false,
    error: null,
    data: null,
  },
  medicationLog: {
    data: null,
    isLoading: false,
    error: null,
  },
};

const medicationSlice = createSlice({
  name: "medication",
  initialState,
  reducers: {
    // get medication list
    getMedicationListRequest: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.medicationsList.isLoading = true;
      state.medicationsList.data = null;
      state.medicationsList.error = null;
    },
    getMedicationListSuccess: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.medicationsList.isLoading = false;
      state.medicationsList.data = action.payload;
      state.medicationsList.error = null;
    },
    getMedicationListError: (
      state: medication.MedicationStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.medicationsList.isLoading = false;
      state.medicationsList.data = null;
      state.medicationsList.error = error;
    },

    // get medication by id

    getMedicationByIdRequest: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.medicationById.isLoading = true;
      state.medicationById.data = null;
      state.medicationById.error = null;
    },

    getMedicationByIdSuccess: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.medicationById.isLoading = false;
      state.medicationById.data = action.payload;
      state.medicationById.error = null;
    },
    getMedicationByIdError: (
      state: medication.MedicationStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.medicationById.isLoading = false;
      state.medicationById.data = null;
      state.medicationById.error = error;
    },

    // add medication
    addMedicationRequest: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.addMedication.isLoading = true;
      state.addMedication.data = null;
      state.addMedication.error = null;
    },
    addMedicationSuccess: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.addMedication.isLoading = false;
      state.addMedication.data = action.payload;
      state.addMedication.error = null;
    },
    addMedicationError: (
      state: medication.MedicationStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.addMedication.isLoading = false;
      state.addMedication.data = null;
      state.addMedication.error = error;
    },

    // edit medication
    editMedicationRequest: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.editMedication.isLoading = true;
      state.editMedication.data = null;
      state.editMedication.error = null;
    },
    editMedicationSuccess: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.editMedication.isLoading = false;
      state.editMedication.data = action.payload;
      state.editMedication.error = null;
    },
    editMedicationError: (
      state: medication.MedicationStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.editMedication.isLoading = false;
      state.editMedication.data = null;
      state.editMedication.error = error;
    },

    // delete medication
    deleteMedicationRequest(
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) {
      state.deleteMedication.isLoading = true;
      state.deleteMedication.data = null;
      state.deleteMedication.error = null;
    },
    deleteMedicationSuccess(
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) {
      state.deleteMedication.isLoading = false;
      state.deleteMedication.data = action.payload;
      state.deleteMedication.error = null;
    },
    deleteMedicationError: (
      state: medication.MedicationStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.deleteMedication.isLoading = false;
      state.deleteMedication.data = null;
      state.deleteMedication.error = error;
    },

    // medication log
    getMedicationLogRequest: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.medicationLog.isLoading = true;
      state.medicationLog.data = null;
      state.medicationLog.error = null;
    },
    getMedicationLogSuccess: (
      state: medication.MedicationStateType,
      action: PayloadAction<any>
    ) => {
      state.medicationLog.isLoading = false;
      state.medicationLog.data = action.payload;
      state.medicationLog.error = null;
    },
    getMedicationLogError: (
      state: medication.MedicationStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.medicationLog.isLoading = false;
      state.medicationLog.data = null;
      state.medicationLog.error = error;
    },
  },
});

export const {
  // get medication list
  getMedicationListRequest,
  getMedicationListSuccess,
  getMedicationListError,

  // get medication by id
  getMedicationByIdRequest,
  getMedicationByIdSuccess,
  getMedicationByIdError,

  // add medication
  addMedicationRequest,
  addMedicationSuccess,
  addMedicationError,

  // edit medication
  editMedicationRequest,
  editMedicationSuccess,
  editMedicationError,

  // delete medication
  deleteMedicationRequest,
  deleteMedicationSuccess,
  deleteMedicationError,

  // medication log
  getMedicationLogRequest,
  getMedicationLogSuccess,
  getMedicationLogError,
} = medicationSlice.actions;

export default medicationSlice.reducer;
